import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const linkStyle = {
    textDecoration: "none",
    color: "rgba(255,255,255,0.8)",
    marginBottom: "0.8rem",
    display: "block",
    cursor: "pointer",
    transition: "color 0.3s ease",
  };

  const linkHover = {
    color: "#9ca3af", // light gray hover
  };

  return (
    <div style={{ backgroundColor: "#0E102D", color: "white" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          padding: "2rem 5rem",
          flexWrap: "wrap",
        }}
      >
        {/* TrustDoc Section */}
        <div>
          <p
            style={{
              marginBottom: "1rem",
              fontWeight: "bold",
              fontSize: "1.1rem",
            }}
          >
            TrustDoc
          </p>

          <Link
            to="/about"
            style={linkStyle}
            onMouseOver={(e) => (e.target.style.color = linkHover.color)}
            onMouseOut={(e) => (e.target.style.color = linkStyle.color)}
          >
            About TrustDoc
          </Link>
          <Link
            to="/contact"
            style={linkStyle}
            onMouseOver={(e) => (e.target.style.color = linkHover.color)}
            onMouseOut={(e) => (e.target.style.color = linkStyle.color)}
          >
            Contact Us
          </Link>
          <Link
            to="/feedback"
            style={linkStyle}
            onMouseOver={(e) => (e.target.style.color = linkHover.color)}
            onMouseOut={(e) => (e.target.style.color = linkStyle.color)}
          >
            Send Us Feedback
          </Link>
          <Link
            to="/careers"
            style={linkStyle}
            onMouseOver={(e) => (e.target.style.color = linkHover.color)}
            onMouseOut={(e) => (e.target.style.color = linkStyle.color)}
          >
            Careers
          </Link>
        </div>

        {/* Get in Touch */}
        <div>
          <p
            style={{
              marginBottom: "1rem",
              fontWeight: "bold",
              fontSize: "1.1rem",
            }}
          >
            Get in Touch
          </p>
          <p style={{ marginBottom: "0.8rem" }}>
            Dubai Silicon Oasis, DDP, Building A2, Dubai.
          </p>
          <p style={{ marginBottom: "0.8rem" }}>+971 505482370</p>
          <a
            href="mailto:support@trust-doc.com"
            style={{
              ...linkStyle,
              color: "rgba(255,255,255,0.8)",
            }}
          >
            support@trust-doc.com
          </a>
        </div>

        {/* Social Media */}
        <div>
          <p
            style={{
              marginBottom: "1rem",
              fontWeight: "bold",
              fontSize: "1.1rem",
            }}
          >
            Follow us on Social Media
          </p>
          <a
            href="https://facebook.com"
            target="_blank"
            rel="noopener noreferrer"
            style={linkStyle}
            onMouseOver={(e) => (e.target.style.color = linkHover.color)}
            onMouseOut={(e) => (e.target.style.color = linkStyle.color)}
          >
            Facebook
          </a>
          <a
            href="https://instagram.com"
            target="_blank"
            rel="noopener noreferrer"
            style={linkStyle}
            onMouseOver={(e) => (e.target.style.color = linkHover.color)}
            onMouseOut={(e) => (e.target.style.color = linkStyle.color)}
          >
            Instagram
          </a>
        </div>
      </div>

      <hr style={{ borderColor: "rgba(255,255,255,0.2)" }} />
      <div style={{ padding: "1rem 5rem" }}>
        <p style={{ color: "rgba(255,255,255,0.7)" }}>
          © 2023 TrustDoc All Rights Reserved.
        </p>
      </div>
    </div>
  );
};

export default Footer;
